import { AfterViewInit, Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { faCamera, faUpload } from '@fortawesome/free-solid-svg-icons';
import { WebcamImage } from 'ngx-webcam';
import { PatientService } from 'src/app/admin/services/patient.service';
import { PractitionerService } from 'src/app/admin/services/practitioner.service';
interface DialogData {
  title: string;
  patientId?: string
  result: boolean;
  currentPicture: string;
  practitionerId: string;
}
@Component({
  selector: 'app-profile-picture-dialog',
  templateUrl: './profile-picture-dialog.component.html',
  styleUrls: ['./profile-picture-dialog.component.scss']
})
export class ProfilePictureDialogComponent implements OnInit, AfterViewInit {

  title;
  question;
  webcamImage: WebcamImage = null;
  uploadedImage: {name: string, source: string | ArrayBuffer};
  showCamera = false;
  faCamera = faCamera;
  faUpload = faUpload;
  @ViewChild('webcamImageDisplay') webcamImageDisplay: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef;
  constructor(public dialogRef: MatDialogRef<ProfilePictureDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private patientService: PatientService, private practitionerService: PractitionerService) { }

  ngOnInit(): void {
    this.title = this.data.title;
  }

  ngAfterViewInit(){
    this.webcamImageDisplay.nativeElement.src = this.data.currentPicture
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  showThumb(image: WebcamImage): void {
    this.webcamImage = image;
    this.webcamImageDisplay.nativeElement.src = image.imageAsDataUrl;
    this.toggleCamera();
  }

  async onFileSelected(event): Promise<void>{
    let reader = new FileReader();
    this.webcamImage = null;
    if (event.target.files && event.target.files.length) {
      const file: File = event.target.files[0];
      reader.readAsDataURL(file);

      reader.onload = () => {
        if (file.type.includes('image')) {
          this.webcamImageDisplay.nativeElement.src = reader.result;
          this.uploadedImage = {
            source: reader.result as any,
            name: file.name
          }
        }
      };
    }
  }

  toggleCamera(){
    this.showCamera = !this.showCamera;
  }

  uploadFile(){
    this.fileInput.nativeElement.value = null;
    this.fileInput.nativeElement.click();
  }

  async saveProfilePicture(): Promise<void>{
    let imageToUpload;
    if(this.webcamImage){
      imageToUpload = {name: 'webcam', source: this.webcamImage.imageAsBase64};
    } else {
      imageToUpload = this.uploadedImage;
    }

    if(this.data.practitionerId){
      this.practitionerService.savePractitionerProfilePicture(this.data.practitionerId, imageToUpload).then(res => {
        this.dialogRef.close();
      }).catch(err => {
        console.log(err);
      });
    }else{
      this.patientService.saveProfilePicture(this.data.patientId, imageToUpload).then(res => {
        this.dialogRef.close();
      }).catch(err => {
        console.log(err);
      });
    }
  }
  
}
